import {switchMap} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ListaService } from '../../../_services/lista.service';
import { NavService } from '../../../_services/_nav.service';
import { Pasos, TipoVigencia} from '../../../_enums/enum';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem } from 'primeng/api';
import { TiposRespaldos, VigenciasSolicitudes, VigenciasSolicitudesReferencias, VigenciasSolicitudesRespaldos } from '../../../_models/vigencias';
import { ListaItem } from '../../../_models/lista-item';
import { ValidityRequestsService } from '../../../_services/vigencias-requisitos.service';
import { ValidityReferencesService } from '../../../_services/vigencias-referencias.service';
import { ValiditySupportingService } from '../../../_services/vigencias-soporte.service';
import { TipoRespaldoService } from '../../../_services/tipo-respaldo.service';

@Component({
  moduleId: module.id,
  templateUrl: './validity-requests-add.component.html',
  selector: 'validity-requests-add-component'
})
export class ValidityRequestsAddComponent implements OnInit{
  displayDialog = false;
  msg: Message;
  vigenciaSolicitud: VigenciasSolicitudes = new VigenciasSolicitudes();
  listTypeValidity: ListaItem[] = [];
  listColumnTable: SelectItem[] = [];
  listTypeValidityColumn: SelectItem[] = [];
  listTableReference: VigenciasSolicitudesReferencias[] = [];
  listTableSupporting: VigenciasSolicitudesRespaldos[] = [];
  loading: boolean = false;
  CodigoPaso = Pasos;
  columnas: any[] = [];
  tableModified = false;
  disponiblesPorFila = new Map<VigenciasSolicitudesReferencias, SelectItem[]>();
  registrosEliminados: (VigenciasSolicitudesReferencias | VigenciasSolicitudesRespaldos)[] = [];
  displayConfirmDelete: boolean = false;
  registroAEliminar: any = null;
  listColumnTableAll: any[] = [];
  longitudMaximaDuracion: number = 6;
  maxDuracion: number = this.generarNueves(this.longitudMaximaDuracion);

  constructor(private listaService: ListaService,
              private router: Router,
              private route: ActivatedRoute,
              private navService: NavService,
              private validityRequestsService: ValidityRequestsService,
              private validityReferencesService: ValidityReferencesService,
              private validitySupportingService: ValiditySupportingService,
              private supportingService: TipoRespaldoService,
              private translateService: TranslateService ) {
  }

  ngOnInit() {
    this.loading = true;
  
    this.route.params.pipe(
      switchMap((params: Params) => this.validityRequestsService.getById(params['id']))
    ).subscribe(data => {
      this.vigenciaSolicitud = data;
      this.setEncabezadoTable();
  
      if (this.vigenciaSolicitud.codigoPaso === Pasos.UNIDADPRODUCTIVA) {
        this.vigenciaSolicitud.indicadorTipo = false;
      }
  
      this.listaService.getMasterDetails('ListasTiposVigencias').subscribe(res => {
        if(res.length > 0){
          this.listTypeValidity = res.filter(
            tipo => tipo.codigo === TipoVigencia.TEMPO || tipo.codigo === TipoVigencia.SINVIG
          );
          this.listTypeValidityColumn = this.listTypeValidity.map(item => ({
            label: item.nombre,
            value: item.idLista
          }));
        }
      });
  
      if (this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA) {
        forkJoin([
          this.listaService.getMasterDetails('ListasTiposReferencias'),
          this.validityReferencesService.getAllEnable()
        ]).subscribe(([listTypeReference, listTypeBackup]) => {
          if(listTypeBackup.length > 0){
            this.listTableReference = listTypeBackup.map(item => ({
              ...item,
              isNew: false
            }));
          }
  
          if(listTypeReference.length > 0){
            this.listColumnTableAll = listTypeReference;
            this.listColumnTable = listTypeReference.map(item => ({
              label: item.nombre,
              value: item.idLista
            }));
          }
          this.actualizarOpcionesDisponibles();
          this.loading = false;
        });
        return;
      }
  
      if (this.vigenciaSolicitud.codigoPaso === Pasos.RESPALDOS) {
        forkJoin([
          this.supportingService.listadoHabilitado(),
          this.validitySupportingService.getAllEnable()
        ]).subscribe(([listTypeBackup, listTypeSupporting]) => {
          if(listTypeSupporting.length > 0){
            this.listTableSupporting = listTypeSupporting.map(item => ({
              ...item,
              isNew: false
            }));
          }
  
          if(listTypeBackup.length > 0){
            this.listColumnTableAll = listTypeBackup;
            this.listColumnTable = listTypeBackup.map(item => ({
              label: item.nombre,
              value: item.idTipoRespaldo
            }));
          } 
          this.actualizarOpcionesDisponibles();
          this.loading = false;
        });
        return;
      }
  
      this.loading = false;
    });
  }
  

  async setEncabezadoTable(){
    this.columnas = [
       { field: 'paso', header: this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA ? await this.translateService.get( 'VIGENCIADEDATOS.LBL_TIPOREFERENCIA' ).toPromise() : await this.translateService.get( 'VIGENCIADEDATOS.LBL_TIPORESPALDO' ).toPromise(), sort: false },
       { field: 'vigencia', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_TIPOVIGENCIA' ).toPromise(), sort: false },
       { field: 'duracionVigencia', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_VIGENCIA' ).toPromise(), sort: false },
       { field: 'acciones', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_ACCIONES' ).toPromise(), sort: false },
    ];
 }

  async preUpdateValidityRequest(event: any) {
    this.loading = true;
    if (event.checked && !this.shouldHideDuration()) {
      const duration = Number(this.vigenciaSolicitud.duracionVigencia);
      if (!duration || duration <= 0) {
        this.msg = {
          severity: 'info', summary: await this.translateService.get('LBL_INFORMACION').toPromise(),
          detail: await this.translateService.get('VIGENCIADEDATOS.MSG_FALTANDATOS').toPromise()
       };
        this.navService.setMesage(4, this.msg);
        setTimeout(() => {
          this.vigenciaSolicitud.indicadorTipo = false;
          this.loading = false;
        });
        return;
      }
    }
    this.loading = false;
  }

  async updateValidityRequest() {
    const isStepFlow = !this.vigenciaSolicitud.indicadorTipo;

    if (isStepFlow && !this.shouldHideDuration()) {
      const duration = Number(this.vigenciaSolicitud.duracionVigencia);
      if (!duration || duration <= 0) {
        this.msg = {
          severity: 'info', summary: await this.translateService.get('LBL_INFORMACION').toPromise(),
          detail: await this.translateService.get('VIGENCIADEDATOS.MSG_FALTANDATOS').toPromise()
       };
        this.navService.setMesage(4, this.msg);
        return;
      }
    }

    if(this.shouldHideDuration()){
      this.vigenciaSolicitud.duracionVigencia = null;
    }

    this.validityRequestsService.update(this.vigenciaSolicitud).subscribe(
      () => {
        const typeMessage = 2; // 1 = Add, 2 = Update, 3 Error, 4 Custom
        this.navService.setMesage( typeMessage, this.msg );
        this.router.navigate(['/apl/vigencias'], { queryParams: { tab: 0 } });
      },
      error => {
        const typeMessage = 3; // 1 = Add, 2 = Update, 3 Error, 4 Custom
        this.navService.setMesage( typeMessage, this.msg );
      }
    );
 }

  getNombreTipoVigencia(id: any): string {
    const tipo = this.listTypeValidity.find(t => t.idLista === id);
    return tipo ? tipo.nombre : '';
  }

  getTipoReferenciaNombre(valor: string): string {
    const tipo = this.listColumnTable.find(t => t.value === valor);
    return tipo ? tipo.label : valor;
  }

  shouldHideDuration(): boolean {
    const selectedId = this.vigenciaSolicitud.idTipoVigencia;
    const selectedType = this.listTypeValidity.find(t => t.idLista === selectedId);
    return selectedType && (selectedType.codigo === TipoVigencia.SINVIG);
  }

  actualizarOpcionesDisponibles() {
    this.disponiblesPorFila.clear();

  if(this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA){
    this.listTableReference.forEach(filaActual => {
      const usados:any[] = this.listTableReference
        .filter(r => r !== filaActual && r.idTipoReferencia != null)
        .map(r => r.idTipoReferencia);

      const disponibles = this.listColumnTable.filter((item:any) =>
        item.value != null &&
        !usados.includes(item.value)
      );
  
      this.disponiblesPorFila.set(filaActual, disponibles);
    });
  }

  if(this.vigenciaSolicitud.codigoPaso === Pasos.RESPALDOS){
    this.listTableSupporting.forEach((filaActual:any) => {
      const usados:any[] = this.listTableSupporting
        .filter(r => r !== filaActual && r.idTipoRespaldo != null)
        .map(r => r.idTipoRespaldo);

      const disponibles = this.listColumnTable.filter((item:any) =>
        item.value != null &&
        !usados.includes(item.value)
      );
  
      this.disponiblesPorFila.set(filaActual, disponibles);
    });
  }
  }

  getTipoSeleccionado(row: any): any {
    return this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA 
      ? row.idTipoReferencia 
      : row.idTipoRespaldo;
  }
  
  setTipoSeleccionado(value: any, row: any): void {
    if (this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA) {
      row.idTipoReferencia = value;
      this.tableModified = true;
      this.actualizarOpcionesDisponibles();
      row.referencia = this.getLabelTipoReferencia(value);
    } else {
      row.idTipoRespaldo = value;
      this.tableModified = true;
      this.actualizarOpcionesDisponibles();
      row.respaldo = this.getLabelTipoReferencia(value);
    }
  }

  limitToThreeDigits(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    if (allowedKeys.includes(event.key)) return;
    const isDigit = /^\d$/.test(event.key);
    if (!isDigit) {
      event.preventDefault();
      return;
    }
    if (value.length === 0 && event.key === '0') {
      event.preventDefault();
      return;
    }
    if (value.length >= this.longitudMaximaDuracion) {
      event.preventDefault();
      return;
    }
  }
  
  validateValue(event: Event, row: any) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    value = value.replace(/^0+/, '');
    if (!value || parseInt(value, 10) <= 0) {
      input.value = '';
      row.duracionVigencia = null;
    } else {
      input.value = value;
      row.duracionVigencia = parseInt(value, 10);
    }
  }

  async saveTableData() {
    this.tableModified = false;

    let listSave:any[] = [];
    if(this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA){
      listSave = this.listTableReference;
    }else{
      listSave = this.listTableSupporting;
    }

    for (const item of listSave) {
      item.idTipoGenerico = this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA ? item.idTipoReferencia : item.idTipoRespaldo;
      if (!item.idTipoGenerico || !item.idTipoVigencia) {
        this.msg = {
          severity: 'info', summary: await this.translateService.get('LBL_INFORMACION').toPromise(),
          detail: await this.translateService.get('VIGENCIADEDATOS.MSG_FALTANDATOS').toPromise()
       };
        this.navService.setMesage(4, this.msg);
        return;
      }
  
      const tipoVigencia = this.listTypeValidity.find(v => v.idLista === item.idTipoVigencia);
  
      if (tipoVigencia && tipoVigencia.codigo === TipoVigencia.TEMPO) {
        if (item.duracionVigencia == null || item.duracionVigencia === '') {
          this.msg = {
            severity: 'info', summary: await this.translateService.get('LBL_INFORMACION').toPromise(),
            detail: await this.translateService.get('VIGENCIADEDATOS.MSG_FALTANDATOS').toPromise()
         };
          this.navService.setMesage(4, this.msg);
          return;
        }
      }
    }

    const referencias = new Set();
    for (const item of listSave) {
      item.idTipoGenerico = this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA ? item.idTipoReferencia : item.idTipoRespaldo;
      if (referencias.has(item.idTipoGenerico)) {
        this.msg = {
          severity: 'info', summary: await this.translateService.get('LBL_INFORMACION').toPromise(),
          detail: await this.translateService.get('VIGENCIADEDATOS.MSG_EXISTEREFERENCIA').toPromise()
       };
        this.navService.setMesage( 4, this.msg );
        return;
      }
      referencias.add(item.idTipoGenerico);
    }
  
    for (const item of listSave) {
      const tipoVigencia = this.listTypeValidity.find(v => v.idLista === item.idTipoVigencia);
  
      if (tipoVigencia && tipoVigencia.codigo === TipoVigencia.TEMPO) {
        if (item.duracionVigencia == null || item.duracionVigencia === '') {
          this.msg = {
            severity: 'info', summary: await this.translateService.get('LBL_INFORMACION').toPromise(),
            detail: await this.translateService.get('VIGENCIADEDATOS.MSG_FALTANDATOS').toPromise()
         };
          this.navService.setMesage( 4, this.msg );
          return;
        }
      }
  
      if (tipoVigencia && tipoVigencia.codigo === TipoVigencia.SINVIG) {
        item.duracionVigencia = null;
      }
    }

    let datosParaGuardar: any[] = [];
    if(this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA){
      datosParaGuardar = this.listTableReference
      .concat(this.registrosEliminados as VigenciasSolicitudesReferencias[])
      .map(item => {
        const ref = this.listColumnTableAll.find((r: ListaItem) => r.idLista === item.idTipoReferencia);
        const vig = this.listTypeValidity.find(v => v.idLista === item.idTipoVigencia);
    
        return {
          ...item,
          idVigenciaSolicitud: this.vigenciaSolicitud.idVigenciaSolicitud,
          idVigenciaSolicitudReferencia: this.vigenciaSolicitud.idVigenciaSolicitudReferencia,
          referencia: item.referencia || (ref as ListaItem).idLista || '',
          vigencia: item.vigencia || vig.idLista || '',
          codigoTipoReferencia: (ref as ListaItem).codigo || '',
          codigoVigencia: vig.codigo || ''
        };
      }); 
    }
    
    if(this.vigenciaSolicitud.codigoPaso === Pasos.RESPALDOS){
      datosParaGuardar = this.listTableSupporting
      .concat(this.registrosEliminados as VigenciasSolicitudesRespaldos[])
      .map(item => {
        const ref = this.listColumnTableAll.find((r: TiposRespaldos) => r.idTipoRespaldo === item.idTipoRespaldo);
        const vig = this.listTypeValidity.find(v => v.idLista === item.idTipoVigencia);
    
        return {
          ...item,
          idVigenciaSolicitud: this.vigenciaSolicitud.idVigenciaSolicitud,
          idVigenciaSolicitudRespaldo: this.vigenciaSolicitud.idVigenciaSolicitudReferencia,
          respaldo: item.respaldo || (ref as TiposRespaldos).idTipoRespaldo || '',
          vigencia: item.vigencia || vig.idLista || '',
          codigoTipoRespaldo: (ref as TiposRespaldos).codigo || '',
          codigoVigencia: vig.codigo || ''
        };
      }); 
    }

    if(this.shouldHideDuration()){
      this.vigenciaSolicitud.duracionVigencia = null;
    }

    if(this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA){
      forkJoin(this.validityReferencesService.bulk(datosParaGuardar),
      this.validityRequestsService.update(this.vigenciaSolicitud)).subscribe(
        () => {
          const typeMessage = 2; // 1 = Add, 2 = Update, 3 Error, 4 Custom
          this.navService.setMesage( typeMessage, this.msg );
          this.router.navigate(['/apl/vigencias'], { queryParams: { tab: 0 } });
      },
      error => {
        const typeMessage = 3; // 1 = Add, 2 = Update, 3 Error, 4 Custom
        this.navService.setMesage( typeMessage, this.msg );
      }
    );
    }
    
    if(this.vigenciaSolicitud.codigoPaso === Pasos.RESPALDOS){
      forkJoin(this.validitySupportingService.bulk(datosParaGuardar),
      this.validityRequestsService.update(this.vigenciaSolicitud)).subscribe(
        () => {
          const typeMessage = 2; // 1 = Add, 2 = Update, 3 Error, 4 Custom
          this.navService.setMesage( typeMessage, this.msg );
          this.router.navigate(['/apl/vigencias'], { queryParams: { tab: 0 } });
      },
      error => {
        const typeMessage = 3; // 1 = Add, 2 = Update, 3 Error, 4 Custom
        this.navService.setMesage( typeMessage, this.msg );
      }
    );
    }
  }
  

  esSinVigencia(TipoVig: any):  boolean {
    const tipo = this.listTypeValidity.find(item => item.idLista === TipoVig);
    return tipo && tipo.codigo === TipoVigencia.SINVIG;
  }

  async add() {
    if(!await this.validateAdd()) return;

    if(this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA){
      const newRow = new VigenciasSolicitudesReferencias();
      newRow.idTipoReferencia = null;
      newRow.idTipoVigencia = null;
      newRow.duracionVigencia = null;
      newRow.isNew = true;
      newRow.indicadorHabilitado = true;
      this.listTableReference = this.listTableReference.concat([newRow]);
      this.tableModified = true;
      this.actualizarOpcionesDisponibles();
    }
    
    if(this.vigenciaSolicitud.codigoPaso === Pasos.RESPALDOS){
      const newRow = new VigenciasSolicitudesRespaldos();
      newRow.idTipoRespaldo = null;
      newRow.idTipoVigencia = null;
      newRow.duracionVigencia = null;
      newRow.isNew = true;
      newRow.indicadorHabilitado = true;
      this.listTableSupporting = this.listTableSupporting.concat([newRow]);
      this.tableModified = true;
      this.actualizarOpcionesDisponibles();
    }
  }

  async validateAdd() {
    const currentItems = this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA 
    ? this.listTableReference 
    : this.listTableSupporting;

    const availableOptions = this.listColumnTableAll.length;
    if (currentItems.length >= availableOptions) {
      if(this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA){
        this.msg = {
          severity: 'info', summary: await this.translateService.get('LBL_INFORMACION').toPromise(),
          detail: await this.translateService.get('VIGENCIADEDATOS.MSG_MAXREFERENCIA').toPromise()
       };
          this.navService.setMesage( 4, this.msg );
      }else{
        this.msg = {
          severity: 'info', summary: await this.translateService.get('LBL_INFORMACION').toPromise(),
          detail: await this.translateService.get('VIGENCIADEDATOS.MSG_MAXRESPALDO').toPromise()
        };
        this.navService.setMesage( 4, this.msg );
      }
      return false;
    }
    return true;
  }
  
  confirmDelete(fila: any) {
    this.registroAEliminar = fila;
    this.displayConfirmDelete = true;
  }

  eliminarFila() {
    if(this.vigenciaSolicitud.codigoPaso === Pasos.REFERENCIA){
      if (this.registroAEliminar && this.registroAEliminar.id) {
        this.registroAEliminar.indicadorHabilitado = false;
        this.listTableReference = this.listTableReference.filter(
          item => item !== this.registroAEliminar
        );
        this.registrosEliminados.push(this.registroAEliminar);
      } else {
        this.listTableReference = this.listTableReference.filter(
          item => item !== this.registroAEliminar
        );
      }
    }
    
    if(this.vigenciaSolicitud.codigoPaso === Pasos.RESPALDOS){
      if (this.registroAEliminar && this.registroAEliminar.id) {
        this.registroAEliminar.indicadorHabilitado = false;
        this.listTableSupporting = this.listTableSupporting.filter(
          item => item !== this.registroAEliminar
        );
        this.registrosEliminados.push(this.registroAEliminar);
      } else {
        this.listTableSupporting = this.listTableSupporting.filter(
          item => item !== this.registroAEliminar
        );
      }
    }
    
    this.registroAEliminar = null;
    this.displayConfirmDelete = false;
    this.actualizarOpcionesDisponibles();
    this.tableModified = true;
  }

  goBack(): void {
    this.router.navigate( [ '/apl/vigencias' ], { queryParams: { tab: 0 } } );
  }

  getLabelTipoReferencia(id: string): string {
    const item = this.listColumnTable.find(x => x.value === id);
    return item ? item.label : '';
  }
  
  getLabelTipoVigencia(id: string): string {
    const item = this.listTypeValidityColumn.find(x => x.value === id);
    return item ? item.label : '';
  }

  generarNueves(n: number): number {
    return +('9'.repeat(n));
  }

}
